export enum ConfigLevel
{
    DealerConfig,
    SiteConfig,
    GroupConfig,
    UserConfig,
    MaskConfig
}
